export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";